import styled from "styled-components";
import {
  LabelDataHeading,
  UnderlyingContent,
  ContentDivider
} from "../../style";
import { DataHeading } from "../../../../../../CommonComponents/commonStyles";
import { Switch } from "antd"

export const CardContainer = styled.div`
  background: ${props => (props.index % 2 ? "#ffffff" : "#f5f5f5")};
  padding: 19px 11px 20px 11px;
  ${({ noPaddingBottom }) =>
    noPaddingBottom &&
    `
    padding: 0px 11px 0px 11px;
    &:first-child {padding: 20px 11px 0px 11px;}
    &:last-child {padding: 0px 11px 20px 11px;}
    `}
    ${({ editableTable }) =>
    editableTable &&
    `
    padding: 10px 11px 10px 11px;
    `}
    @media only screen and (max-width: 373px) {
      padding: 10px 11px 10px 11px;

    }

    `;
export const ModelDataHeading = styled(LabelDataHeading)`
  margin-right: 5px;
  margin-bottom: 15px;
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.13;
  }
`;

export const UnderlineLinkBold = styled(UnderlyingContent)`
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1;
  }
`;
export const PopupContentDivider = styled(ContentDivider)`
  margin-top: 14px;
  margin-bottom: 10px;
`;

export const GrantAllocationSwitch = styled(Switch)`
  &.mobile-switch {
    height: 15px;
    min-width: 39px;
  }
  &.mobile-switch.ant-switch::after {
    top: -5px;
    left: -2px;
    width: 22px;
    height: 22px;
  }
  &.mobile-switch.ant-switch-checked::after {
    left: 107%;
  }
  &.ant-switch-checked {
    background-color: ${props => props.theme.colors.primaryColor} !important;
  }
`;

export const CardDataHeadingValue = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: 1.43;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
`;

export const LabelDataHead = styled(DataHeading)`
  color: ${props => props.theme.fontColors.textColor};
`;

export const ValueDataHeading = styled(DataHeading)`
  color: ${props => props.theme.fontColors.textColor};
  text-transform: capitalize;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const LinkHeading = styled.div`
  color: ${props => props.theme.fontColors.textColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  padding-bottom: 20px;
  font-size: ${props => props.theme.fontSize.secondary};
  ${({underline})=>underline&&`
    text-decoration: underline;
  `}
`;
